<template>
    <grid-layout>
        <grid-layout-item
            v-for="inventory in inventories"
            :key="inventory.uuid"
            class="mt-3 md:mt-6 md:w-1/2"
        >
            <with-dimensions>
                <router-link
                    slot-scope="{ width }"
                    :to="{
                        name: $router.fix('dashboard.*.inventories.show'),
                        params: {
                            inventory: inventory.uuid
                        }
                    }"
                    class="flex w-full bg-white shadow rounded no-underline text-inherit hover:bg-blue-bg"
                >
                    <div
                        :style="{
                            'background-image': 'url(' + $laroute.route('storage.files.show', {
                                file: inventory.files.data[0].uuid,
                                width: 150,
                                height: 150,
                                greyscale: !!inventory.files.data[0].erased_at
                            }) + ')'
                        }"
                        :class="[
                            inventory.files.data[0].mime_type === 'application/pdf' ? 'bg-top' : 'bg-center',
                            width > 345 ? 'w-24 h-24' : 'w-16 h-16'
                        ]"
                        class="relative flex-none bg-cover rounded-l"
                    />

                    <div class="flex-1 overflow-hidden flex flex-col p-3 border-l">
                        <div class="flex-grow">
                            <header class="truncate">{{ inventory.title }}</header>

                            <div
                                v-if="width > 345"
                                class="text-sm text-grey-darker truncate"
                            >
                                <template v-if="inventory.description">
                                    {{ inventory.description }}
                                </template>
                                <template v-else>
                                    <em class="italic">No description</em>
                                </template>
                            </div>
                        </div>

                        <div class="flex-none flex -mx-3 text-label text-2xs leading-none">
                            <div class="inline-flex items-center ml-3">
                                <base-svg
                                    name="icon-document"
                                    class="w-3 h-3 block mr-1"
                                />

                                {{ inventory.files.meta.total }} file{{ inventory.files.meta.total === 1 ? '' : 's' }}
                            </div>
                        </div>
                    </div>
                </router-link>
            </with-dimensions>
        </grid-layout-item>
    </grid-layout>
</template>

<script>
    export default {
        props: {
            inventories: {
                type: Array,
                required: true
            }
        }
    }
</script>
